<template>
    <div :style="tabStyle ? 'position: relative;' : ''">
        <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />
        <div class="wrap" :class="tabStyle ? 'tab-style' : ''">
            <div class="unit" :class="tabStyle ? 'tab-style' : ''">(元/份)</div>
            <div ref="content" class="unified-meal" :style="`animation-duration:${animationDuration}s`">
                <div class="daily-type" :class="tabStyle ? 'tab-style' : ''" v-for="(wrapItem, wrapIndex) in infos"
                    :key="wrapIndex">
                    <div class="daily-title" :class="tabStyle ? 'tab-style' : ''">
                        <span>{{ wrapItem.typeName }}</span>
                        <span v-if="tabStyle" class="daily-subtitle">(元/份)</span>
                    </div>
                    <div class="daily-tr daily-header" :class="tabStyle ? 'tab-style' : ''">
                        <div>菜品</div>
                        <div>价格</div>
                        <div>指导价</div>
                        <div>比升降</div>
                    </div>
                    <div class="daily-tr daily-list" :class="tabStyle ? 'tab-style' : ''"
                        v-for="(subItem, subIndex) in wrapItem.list" :key="subIndex">
                        <div>{{ subItem.name || '--' }}</div>
                        <div>{{ subItem.price || '--' }}</div>
                        <div>{{ subItem.guidePrice || '--' }}</div>
                        <div class="img-wrap">
                            <img class="img" :src="renderArrow(subItem.compareIncreaseDecrease)">
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { formatTime } from '@/assets/js/common'
import schoolAndDate from "./schoolAndDate.vue";
export default {
    props: {
        schoolName: {
            type: String,
            default: '',
        },
        dateTime: {
            type: String,
            default: '',
        },
        deptId: {
            type: String,
            default: ''
        },
        outletsId: {
            type: String,
            default: ''
        },
        tabStyle: {
            type: Boolean,
            default: false,
        },
    },
    components: { schoolAndDate, },
    data() {
        return {
            iconArrUp: require("@/assets/images/icon_arrow_up.png"),
            iconArrDown: require("@/assets/images/icon_arrow_down.png"),
            iconArrNot: require("@/assets/images/icon_arrow_not.png"),
            infos: [],
            animationDuration: 0
        }
    },
    computed: {},
    mounted() {
        this.getFoodInformationList()
    },
    methods: {
        // 获取餐次信息
        getFoodInformationList() {
            const param = {
                deptId: this.deptId,
                outletsId: this.outletsId,
                queryDate: formatTime(new Date(), 'yyyy-MM-dd'),
            }
            /**
             * 后台返回示例：0: [{
                                "name": "早餐","price":"1.0","guidePrice":"10~12","compareIncreaseDecrease":"lt"
                                }]
                0:早餐 1:中餐 2:晚餐 3:夜餐 4:统缴餐
             */
            this.$get(this.$api.getFoodInformationList, param).then(res => {
                const { code, success, data } = res
                try {
                    if (code == 200 && success) {
                        const arrList = []
                        for (const key in data) {
                            arrList.push({
                                typeName: { 0: '早餐', 1: '中餐', 2: '晚餐', 3: '夜餐', 4: '统缴餐' }[`${key}`],
                                list: data[`${key}`],
                            })
                        }
                        this.infos = JSON.parse(JSON.stringify(arrList))
                        console.log('===> 当天餐价公示数据结构 <===', JSON.parse(JSON.stringify(data)))
                        console.log('===> 重新组合后数据结构 <===', JSON.parse(JSON.stringify(this.infos)))

                        this.$nextTick(() => {
                            this.calcDocumentHeight()
                        })
                    }

                } catch (error) {
                    console.error('===> error <===', error)
                }
            })
        },

        renderArrow(value) {
            if (value === 'gt') {
                return this.iconArrUp
            }
            if (value === 'lt') {
                return this.iconArrDown
            }
            return this.iconArrNot
        },

        // 计算高度
        calcDocumentHeight() {
            if (this.$refs.content.offsetHeight > 900) {
                this.animationDuration = (this.$refs.content.offsetHeight / 200) * 2.5
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@keyframes scroll-up {
    0% {
        transform: translateY(0);
        /* 文本初始位置，向上偏移 0 */
    }

    100% {
        transform: translateY(-100%);
        /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
    }
}

$originFontColor: #3CEAFF;
$tabStyleFontColor: #A84E14;

.wrap {
    height: vh(766);
    width: 100%;
    overflow: hidden;


    &.tab-style {
        background: #efbcaf;
        background-size: 100% 100%;
    }

    .unit {
        position: absolute;
        top: vh(50);
        right: vh(20);
        color: $originFontColor;
        font-size: vh(16);

        &.tab-style {
            color: #FFF;
            display: none;
        }
    }
}

.daily-type {
    @include font(22, #FFF, center);

    &.tab-style {
        color: $tabStyleFontColor;
    }

    .daily-title {
        color: $originFontColor;
        font-size: vh(32);
        margin: vh(40) auto vh(30);
        position: relative;

        &.tab-style {
            color: $tabStyleFontColor;
        }

        .daily-subtitle {
            font-size: vh(14);
            position: absolute;
            right: vh(40);
            bottom: 0;
        }
    }

    .daily-tr {
        display: flex;

        >div {
            flex: 1;
        }

        >div:first-of-type {
            text-align: left;
            padding-left: vh(40);
            white-space: break-spaces;
        }

        &.daily-header {
            background: url('../assets/images/daily_header_bg.png') 0 0 no-repeat;
            background-size: 100% 100%;
            color: $originFontColor;
            padding: vh(8) 0;

            &.tab-style {
                color: $tabStyleFontColor;
                background: #f3ae9a;
            }
        }

        &.daily-list {
            padding: vh(20) 0;
            border-bottom: 1px solid #01548E;

            &.tab-style {
                border-color: $tabStyleFontColor;
            }
        }
    }

    .img {
        width: vh(14);
    }
}

.unified-meal {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    animation-name: scroll-up;
    animation-duration: 0;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
</style>